import React from 'react';
import ErrorPageLayout from '../../components/ui/ErrorPageLayout';

/**
 * A route component for a critical error
 */
const CriticalError = ({ critical = false }) => {
  return (
    <ErrorPageLayout
      title="Critical Error"
      message="We're sorry, an unexpected critical error has occurred."
    />
  );
};

export default CriticalError;
